import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  setInvertedTheme,
  unsetInvertedTheme,
  setIsOnWhitePage,
  unsetIsOnWhitePage
} from '../actions/ui';
import Page from '../components/Page';

const mapStateToProps = state => ({
  invertedTheme: state.ui.invertedTheme,
  bookCategory: state.book.book ? state.book.book.bookCategory : '',
  bookTitle: state.book.book ? state.book.book.title : '',
  bookId: state.book.book ? state.book.book.id : null
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setInvertedTheme,
      unsetInvertedTheme,
      setIsOnWhitePage,
      unsetIsOnWhitePage
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);



// WEBPACK FOOTER //
// ./src/containers/PageContainer.js